<template>
  <COverflowWrapper :max-height="480">
    <NForm class="theme-colors-step" :show-feedback="false" size="medium">
      <NGrid :cols="1" :y-gap="24">
        <NFormItemGridItem :label="t('canvasUI.CThemeColorsStep.backgroundColor')">
          <NColorPicker
            :actions="['clear', 'confirm']"
            :modes="['hex']"
            :on-clear="() => emit('update:modelValue', { ...modelValue, background_color: themeVars.base })"
            :swatches="modelValue.palette?.length ? modelValue.palette : undefined"
            :value="modelValue.background_color"
            @update:value="(value: string) => emit('update:modelValue', { ...modelValue, background_color: value })"
          />
        </NFormItemGridItem>

        <NFormItemGridItem :label="t('canvasUI.CThemeColorsStep.palette', { count: modelValue.palette.length })">
          <CPaletteConfigurator
            allow-order
            class="w-full"
            :initial-palette="modelValue.palette ?? []"
            @update:palette="
              (newPalette: string[]) => emit('update:modelValue', { ...modelValue, palette: newPalette })
            "
          />
        </NFormItemGridItem>
      </NGrid>
    </NForm>
  </COverflowWrapper>
</template>

<script setup lang="ts">
import { NForm, NFormItemGridItem, NGrid, NColorPicker } from 'naive-ui'
import { useI18n } from 'vue-i18n'

import CPaletteConfigurator from '@lib/components/CPaletteConfigurator/CPaletteConfigurator.vue'
import COverflowWrapper from '@lib/components/COverflowWrapper/COverflowWrapper.vue'

import useThemeVars from '@lib/composables/useThemeVars'

import type { CanvasThemeSettings } from '@lib/types/canvasTheme'

defineProps<{
  modelValue: Pick<CanvasThemeSettings, 'background_color' | 'palette'>
}>()

const emit = defineEmits<{
  'update:modelValue': [value: Pick<CanvasThemeSettings, 'background_color' | 'palette'>]
}>()

const { t } = useI18n()
const themeVars = useThemeVars()
</script>

<style scoped>
.color-preview {
  border: 1px solid var(--border-color);
}
</style>
